<template>
    <div class="py-80 px-40">
        <el-form button-class="btn btn-green btn-rounded w-full font-bold" :submit-text="translations.post_review">
            <h2 class="h5 mb-16">{{ translations.write_a_review }}</h2>
            <score-stars @score-stars-input="setScore" :score="5" :large="true" :input="true" class="mb-40"></score-stars>
            <el-input v-model="newReview.title" rules="required" :label="translations.title_label" class="mb-16"></el-input>
            <el-input v-model="newReview.text" rules="required" :label="translations.description" type="textarea" class="mb-16"></el-input>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "Ui.SlideoutReview",

    props: {
        translations: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            newReview: {
                score: 5,
                title: '',
                text: ''
            }
        }
    },

    methods: {
        setScore(score) {
            this.newReview.score = score;
        }
    }
}
</script>